import '../../App.css'


export default function CodebaseHome() {
    return (
      <h2>Codebase Home</h2>
    
    );
  }